
// define the carousel init within a function that can be executed after asynchronous load of additional HTML content
var carouselInit =

    function () {



        if (!mobileMarqueeImg) {
            var mobileMarqueeImg = [];
        }

        if (!desktopMarqueeImg) {
            var desktopMarqueeImg = [];
        }

        //Serve up the mobile version of the animation if on mobile device, swap out the marquee images, and show the order now button

        function marqueeImgSwap(imageArray) {
            var marqueeImg = document.getElementsByClassName("marquee-image");
            for (i = 0; i < marqueeImg.length; i++) {
                marqueeImg[i].setAttribute('src', imageArray[i]);
            }
        }

        var resizeTimer;

        $(window).resize(function (e) {

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                if ($(window).width() < 939) {
                    marqueeImgSwap(mobileMarqueeImg);
                } else {
                    marqueeImgSwap(desktopMarqueeImg);
                }
            }, 5);

        });

        if ($(window).width() < 939) {
            marqueeImgSwap(mobileMarqueeImg);
        }

        // ADA keyboard support for Owl Carousel

        // get page direction for carousel variable
        var direction;
        (document.dir != undefined) ? direction = document.dir : direction = document.getElementsByTagName("html")[0].getAttribute("dir");       
        $('#close-bread').click(function (e) {
            e.preventDefault();
            $('.bread-carousel-container').fadeOut();
            $('.product-card').removeClass('disabled'); // enable product summary card on close
            $('html').removeClass('noscroll'); // remove noscroll from html
        });


        // set carousel container for marquee
        var $carouselContainer = $("#carousel-marquee-container");

        $carouselContainer.owlCarousel({
            items: 1,
            scrollPerPage: true,
            navigation: false,
            pagination: true,
            direction: direction, // direction must change for RTL support
            itemsDesktop: [1199, 1],
            itemsDesktopSmall: [960, 1],
            itemsTablet: [720, 1],
            itemsMobile: [320, 1],
            afterInit: afterInitKeydown($carouselContainer),
            afterAction: afterActionMarquee,
            autoPlay: 10000,
            slideSpeed: 20000,
            stopOnHover: true
        });
        function afterInitKeydown(el) {
            var owl = this.owl;
            // owl carousel's afterInit callback is fired only once after initialisation
            el.on("keydown", function (e) {
                // override the default keyboard behaviour only for the wrapper and not everything inside it
                var code = e.keyCode || e.which; // get the code of key pressed
                if (code === keyCodes.RIGHT) {
                    el.data('owlCarousel').next();
                    // arrow right - next slide
                } else if (code === keyCodes.LEFT) {
                    el.data('owlCarousel').prev(); // arrow left - previous slide
                }
            });
        }

        function afterActionMarquee() {
            var owl = this.owl;
            // owl carousel's afterAction callback is fired after every user interaction and also after initialisation
            carouselADA(owl, 'marquee');
        }       
        //loop thru each owl carousel item, if it is currently visible on screen add a tabindex of 0 if it is off screen tabindex of -1 to make untabbable 
        function carouselADA(owl, name) {
            for (i = 0; i <= owl.owlItems.length - 1; i++) {
                if (i >= owl.visibleItems[0] && i <= owl.visibleItems[owl.visibleItems.length - 1]) {
                    var tabindex = document.createAttribute('tabindex');
                    tabindex.value = '0';
                } else {
                    var tabindex = document.createAttribute('tabindex');
                    tabindex.value = '-1';
                }
                if (name === 'rewards') {
                    owl.owlItems[i].childNodes[0].childNodes[1].childNodes[7].attributes.setNamedItem(tabindex);
                } else if (name === 'marquee') {
                    owl.owlItems[i].childNodes[0].childNodes[1].attributes.setNamedItem(tabindex);
                }
            }
        };
    };


carouselInit();
